import { Box, Button, ButtonGroup, Code, DialogBody, DialogFooter, Separator, Spinner, Stack, Text } from "@chakra-ui/react";
import { UI } from "components";
import { API, toaster } from "config";
import { useEffect, useState } from "react";

export default function Pix({ data = {}, ...props }) {

    const [loading, setLoading] = useState(false)
    const [pixData, setPixData] = useState(null)

    useEffect(() => {
        if (props.open) fetchPix()
        else setPixData(null)
    }, [props.open])

    const fetchPix = async () => {
        setLoading(true)
        try {
            const res = await API.get(`/transactions/${data.id}/pix`)
            setPixData(res.data)
        } catch (err) {
            toaster.create({ title: 'Não foi possível gerar o QR Code Pix', description: err?.response?.data?.message, type: 'warning' })
            props.onClose()
        }
        setLoading(false)
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(pixData?.pix?.code)
        toaster.create({ title: 'Código Pix copiado!', type: 'success' })
    }

    return (
        <UI.Dialog size="sm" title={<><UI.Icon name="pix" /> Pagar com Pix</>} {...props}>
            <DialogBody>
                <Stack gap={4} align="center">

                    <UI.Show visible={loading}>
                        <Spinner size="xl" color="orange.500" />
                        <Text fontSize="sm" color="GrayText">Gerando QR Code...</Text>
                    </UI.Show>

                    <UI.Show visible={!loading && !!pixData}>
                        <Text fontSize="sm" color="GrayText" textAlign="center">
                            Escaneie o QR Code abaixo ou copie o código Pix para realizar o pagamento.
                        </Text>

                        <UI.Show visible={!!pixData?.pix?.qrcode}>
                            <Box w="220px" h="220px">
                                <img src={pixData?.pix?.qrcode} alt="QR Code Pix" style={{ width: '100%', height: '100%' }} />
                            </Box>
                        </UI.Show>

                        <Separator w="100%" />

                        <Box w="100%">
                            <Text fontSize="xs" color="GrayText" mb={1}>Código Pix (copia e cola):</Text>
                            <Code fontSize="xs" w="100%" p={2} borderRadius={4} whiteSpace="pre-wrap" wordBreak="break-all">
                                {pixData?.pix?.code}
                            </Code>
                            <Button mt={2} size="xs" w="100%" colorPalette="orange" onClick={handleCopy}>
                                <UI.Icon name="pix" /> Copiar código Pix
                            </Button>
                        </Box>

                        <UI.Show visible={!!pixData?.account?.name}>
                            <Box w="100%" p={3} borderWidth={1} borderRadius={4} borderStyle="dashed">
                                <Text fontSize="xs" color="GrayText">Beneficiário:</Text>
                                <Text fontSize="sm" fontWeight="bold">{pixData?.account?.name}</Text>
                                <UI.Show visible={!!(pixData?.account?.bank?.short_name ?? pixData?.account?.bank?.name)}>
                                    <Text fontSize="xs" color="GrayText">{pixData?.account?.bank?.short_name ?? pixData?.account?.bank?.name}</Text>
                                </UI.Show>
                            </Box>
                        </UI.Show>

                        <UI.Alert size="sm" colorPalette="orange" w="100%">
                            Após realizar o pagamento via Pix, aguarde a confirmação do núcleo vendedor ou anexe o comprovante de pagamento.
                        </UI.Alert>
                    </UI.Show>

                    <UI.Show visible={!loading && !pixData?.pix?.qrcode && !!pixData}>
                        <UI.Alert size="sm" colorPalette="red" w="100%">
                            O núcleo vendedor não possui chave Pix cadastrada. Entre em contato diretamente com o núcleo para realizar o pagamento.
                        </UI.Alert>
                        <UI.Show visible={!!pixData?.account?.pix_key === false}>
                            <Box w="100%" p={3} borderWidth={1} borderRadius={4} borderStyle="dashed">
                                <Text fontSize="xs" color="GrayText">Núcleo vendedor:</Text>
                                <Text fontSize="sm" fontWeight="bold">{pixData?.account?.name}</Text>
                            </Box>
                        </UI.Show>
                    </UI.Show>

                </Stack>
            </DialogBody>
            <DialogFooter>
                <ButtonGroup>
                    <Button variant="ghost" onClick={props.onClose}>Fechar</Button>
                </ButtonGroup>
            </DialogFooter>
        </UI.Dialog>
    )
}
